export async function handle400Error(error, originalRequest) {
    const resData = error?.response?.data;
    if (!resData) {
        return Promise.reject(error);
    }
    return Promise.reject(error);
}
